import safelyIncrement from '../../helpers/safelyIncrement';

export default (state, action) => {
  const { itemCount } = state;
  const { containerId } = action.payload;

  const updatedItemCount = {
    ...itemCount,
    [containerId]: safelyIncrement(itemCount[containerId]),
  };

  return {
    ...state,
    itemCount: updatedItemCount,
  };
};
